<zimmerer-route-ion-wrapper class="ion-page">

  <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center">

    <div class="main-col withBottomPadding" [class.withTopPadding]="MobileService.isMobile"
      [class.noSlider]="!hasSliderImages" fxLayout="column" fxLayoutGap="20px">

      <image-slider [fxHide]="!hasSliderImages" [page]="'profile'" fxHide.lt-lg></image-slider>

      <div fxLayout="column" fxLayoutGap="15px" fxLayoutAlign="start center" fxLayout.gt-md="row">
        <img class="woodcoin" [src]="environment.publicFolder+'assets/images/woodcoin.svg'">
        <h1 class="mainheadline">Mein Bonusbereich</h1>
      </div>

      <div>Sammle Bonuspunkte "Woodcoins" <span><img style="width: 25px;"
            [src]="environment.publicFolder+'assets/images/woodcoin.svg'"></span> und räume tolle Preise ab! Wie das
        genau
        geht, erfährst du unter "Spielregeln & Preise"</div>

      <div class="card" fxLayout="column" fxLayoutGap="34px">
        <h2 class="headline">Übersicht Bonus Level</h2>

        <level-progress-bar [levels]="levels"></level-progress-bar>

        <div fxLayout="column" fxLayoutGap="34px" fxLayout.gt-md="row" fxLayoutAlign.gt-md="space-between center"
          fxLayoutGap.gt-md="0px">
          <div class="text1">Schreiben, Liken, aktiv werden und Woodcoins sammeln!</div>
          <button class="orange-button" (click)="StateService.goto('/boni/faq')">Spielregeln & Preise</button>
        </div>
      </div>

      <div class="card currentLevel" *ngIf="currentLevel">
        <h2 class="headline">Dein aktuelles Level</h2>

        <div fxLayout="column" fxLayoutGap="34px" fxLayout.gt-md="row" fxLayoutAlign.gt-md="space-between center"
          fxLayoutGap.gt-md="10px">

          <div fxLayout="column" fxLayoutGap="10px" fxFlex.gt-md="40">
            <div class="subline">Level {{currentLevel.level}}: {{currentLevel.title}}</div>
            <div [innerHTML]="currentLevel.description"></div>
          </div>

          <div fxLayout="column" fxLayoutAlign.lt-lg="center center">
            <img class="lvlimg" [src]="currentLevel.image">
          </div>

          <div fxLayout="column">
            <div fxLayout="row" fxLayoutAlign="start center">
              <div fxLayout="column" fxLayoutGap="10px">
                <div class="subline">Dein Preis:</div>
                <div>{{currentLevel.bonus_present}}</div>
              </div>
              <div>
                <img class="prizeimg" [src]="currentLevel.prize_image">
              </div>
            </div>

            <button *ngIf="currentLevel.pivot.redeemed==0" class="orange-button"
              (click)="redeemBonus(currentLevel)">Jetzt Preis erhalten</button>

            <div
              *ngIf="currentLevel.pivot.redeemed==1 && currentLevel.pivot.redeemed_at && moment.isMoment(currentLevel.pivot.redeemed_at)">
              eingelöst am {{ currentLevel.pivot.redeemed_at.format("DD.MM.YYYY") }}
            </div>
          </div>

        </div>
      </div>

      <div fxLayout="column" fxLayoutGap="46px" fxLayout.gt-md="row">

        <!-- next level -->
        <div class="card nextLevel" *ngIf="nextLevel" fxLayout="column" fxLayoutAlignlt-lg="center center"
          fxFlex.gt-md="40">
          <h2 class="headline">Dein nächstes Level</h2>
          <div class="subline">Level {{nextLevel.level}}: {{nextLevel.title}}</div>
          <div fxFlex="grow" fxLayout="column" fxLayoutAlign="center center">
            <img class="lvlimg" [src]="nextLevel.image">
          </div>
          <div style="text-align: center; font-family:'Roboto-Light';">
            <div>Dein nächster Preis:</div>
            <div>{{nextLevel.bonus_present}}</div>
          </div>

          <div fxFlex="grow" fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-md="end end">
            <button class="orange-button" (click)="openTodoDialog()">Jetzt loslegen</button>
          </div>

        </div>

        <!-- stats -->
        <div fxFlex="60" class="card" fxLayout="column" fxLayoutGap="46px">

          <h2 class="headline">Deine Statistik</h2>

          <profile-statistics></profile-statistics>

          <div fxFlex="grow" fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-md="end end">
            <button class="orange-button" (click)="openTodoDialog()">Jetzt loslegen</button>
          </div>
        </div>
      </div>

    </div>
  </div>

  <app-footer></app-footer>

</zimmerer-route-ion-wrapper>